<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" size="small" :ref="searchForm">
          <el-col>
            <el-form-item label="客户名称：">
              <el-select size="medium" v-model="searchForm.customer" style="width: 100%" @change="queryProject($event)" filterable>
                <el-option v-for="item in customers" :key="item.TC_ID" :label="item.NAME" :value="item.TC_ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目点：">
              <el-select size="medium" v-model="searchForm.project" style="width: 100%" @change="getDkList($event)" filterable>
                <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="档口：">
              <el-select size="medium" v-model="searchForm.dkId" style="width: 100%" @change="getClassList($event)" filterable>
                <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="DEFAULT_NUM" label="就餐人数"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openEdit(scope.row)" type="text">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增/修改模态框 -->
    <el-dialog title="编辑" center :visible.sync="editFormVisible" width="380px">
      <el-form :model="editForm" ref="editForm" size="small" :inline="true" :label-width="formLableWidth">
        <el-form-item label="客户名称：" v-show="editFlag == 0">
          <el-select v-model="editForm.customer" @change="queryProject($event)" filterable style="width: 93%">
            <el-option v-for="item in customers" :key="item.TC_ID" :label="item.NAME" :value="item.TC_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" v-show="editFlag == 0">
          <el-select v-model="editForm.project" @change="getDkList($event)" filterable style="width: 93%">
            <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：" v-show="editFlag == 0">
          <el-select v-model="editForm.dkId" filterable @change="getClassList($event)" style="width: 93%">
            <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="就餐人数：">
          <el-input v-model="editForm.DEFAULT_NUM" style="width: 100%" @change="DefaultNum"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryMealCountFun, addMealCountFun, editMealCountFun } from 'api/packageManage';
import { selectProjectFun, selectAllCusFun, selectDKFun } from 'api/sellOrder';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      searchForm: {},
      editFlag: 0,
      editFormVisible: false,
      editForm: {},
      dkList: [],
      projects: [],
      customers: [],
      formLableWidth: '100px',
    };
  },
  created() {
    this.queryCustomer();
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.customer) {
        params.TC_ID = this.searchForm.customer;
      }
      if (this.searchForm.project) {
        params.PROJECT_ID = this.searchForm.project;
      }
      if (this.searchForm.dkId) {
        params.DK_ID = this.searchForm.dkId;
      }
      queryMealCountFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    DefaultNum(e) {
      this.editForm.DEFAULT_NUM = e;
    },
    queryCustomer() {
      selectAllCusFun()
        .then((result) => {
          if (result.length !== 0) {
            this.customers = result;
          } else {
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    queryProject(event) {
      console.log(event);
      for (let i = 0; i < this.customers.length; i++) {
        if (this.customers[i].ID === event) {
          sessionStorage.setItem('TC_NAME', this.customers[i].AB_NAME);
        }
      }
      const paramsProject = {
        TC_ID: event,
      };
      selectProjectFun(paramsProject)
        .then((result) => {
          this.projects = result[0].list;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------选择项目点
    getDkList(event) {
      console.log('项目点', event);
      for (let i = 0; i < this.projects.length; i++) {
        if (this.projects[i].ID === event) {
          sessionStorage.setItem('PROJECT_NAME', this.projects[i].NAME);
        }
      }
      const params = {
        TC_ID: this.editForm.customer,
        PROJECT_ID: event,
      };
      selectDKFun(params).then((res) => {
        this.dkList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------选择档口
    getClassList(event) {
      console.log('档口', event);
    },
    openAdd() {
      this.editFormVisible = true;
      this.editFlag = 0;
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editFlag = 1;
      this.editForm = row;
      this.dinneriList = JSON.parse(row.DEFAULT_NUM);
    },
    close() {
      this.editForm.DEFAULT_NUM = this.dinneriList;
      this.editFormVisible = false;
    },
    submitAdd() {
      const params = {
        DK_ID: this.editForm.dkId,
        DEFAULT_NUM: this.editForm.DEFAULT_NUM,
      };
      if (this.editFlag == 0) {
        if (!this.editForm.customer || !this.editForm.project || !this.editForm.dkId || !this.editForm.DEFAULT_NUM) {
          this.$message.show({ text: '请输入客户名称、项目点、档口和正数就餐人数', type: 'warning' });
          return false;
        }
        addMealCountFun(params).then((result) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.editForm = {};
          this.queryData();
          this.editFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        if (!this.editForm.DEFAULT_NUM) {
          this.$message.show({ text: '请输入正数就餐人数', type: 'warning' });
          return false;
        }
        params.ID = this.editForm.ID;
        editMealCountFun(params).then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.editForm = {};
          this.queryData();
          this.editFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/mealCountSet.vue